import type { ReactNode } from 'react';

import { LocalizationProvider } from '@app/contexts/localization';
import useCurrentAgreement from '@app/hooks/use-current-agreement';

import { DocumentTranslationsLoader } from './document-translations-loader';

type Props = {
  children: ReactNode;
  isGuest: boolean;
};

export const DocumentLocalization = ({ children, isGuest }: Props) => {
  const { language } = useCurrentAgreement();

  return (
    <DocumentTranslationsLoader
      isGuest={isGuest}
      language={language as string}
    >
      <LocalizationProvider language={language as string}>{children}</LocalizationProvider>
    </DocumentTranslationsLoader>
  );
};
